import { InputLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingStatusSelect = ({ value, onChange, error, helperText, ...selectProps }) => {
  const { t } = useTranslation();

  const handleChange = event => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl error={error}>
      <InputLabel>{t('billing.billingStatus', 'Billing Status')}</InputLabel>
      <Select
        {...selectProps}
        label={t('billing.billingStatus', 'Billing Status')}
        value={value != null && value != undefined ? value : 'all'}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': t('billing.selectBillingStatus', 'Select Billing Status') }}
        sx={{ minWidth: '140px' }}
      >
        <MenuItem value="" disabled>
          {t('billing.selectBillingStatus', 'Select Billing Status')}
        </MenuItem>
        <MenuItem value="all">{t('billing.all', 'All')}</MenuItem>
        <MenuItem value="ready">{t('billing.ready', 'Ready')}</MenuItem>
        <MenuItem value="complete">{t('billing.complete', 'Complete')}</MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default BillingStatusSelect;
